import { Image, Modal, Text } from "@mantine/core";
import { Fragment, useState } from "react";
import { useTranslation } from "next-i18next";
import { useColors } from "../../../../../hooks/colors/useColors";
import { MyButton } from "../../../../UI/my-button/MyButton";
import { AppointmentDTO } from "../../../../../hooks/react-query/useAppointmentList";
import { showLocalizedDateTime } from "../../../../../services/dateAndTime/dateAndTimeUtil";

type InputProps = {
  appointmentDTO: AppointmentDTO;
};

export function PaymentStatus(props: InputProps) {
  const { appointmentDTO } = props;
  const { appointment, payment } = appointmentDTO;
  const [openModal, setOpenModal] = useState<boolean>(false);
  // const [openRetryModal, setOpenRetryModal] = useState<boolean>(false);
  const { colors } = useColors();
  const { i18n } = useTranslation("common");

  function closeModal() {
    setOpenModal(false);
  }

  return (
    <Fragment>
      {payment && (
        <Fragment>
          <MyButton
            className="p-0 my-2"
            onClick={() => setOpenModal(true)}
            title={i18n.t(
              i18n.t(
                payment.paymentStatus === "PAID"
                  ? "payment.paid"
                  : payment.paymentStatus === "PENDING"
                  ? "payment.payment-pending"
                  : "payment.payment-failed"
              )
            )}
            textColor={
              payment.paymentStatus === "PAID"
                ? colors.teal
                : payment.paymentStatus === "PENDING"
                ? colors.warning
                : colors.danger
            }
            color={colors.primary}
          />
          <Modal opened={openModal} onClose={closeModal} centered>
            <Text className="text-center !text-2xl !mb-6 !font-bold">
              {showLocalizedDateTime(
                appointment.dateTime,
                i18n.language,
                "LL, LT"
              )}
            </Text>
            <div className="space-y-6 mb-4">
              <div>
                <span className="text-xl font-bold">{`${i18n.t(
                  "payment.status"
                )}: `}</span>
                <span
                  className="uppercase font-bold"
                  style={{
                    color:
                      payment.paymentStatus === "PAID"
                        ? colors.teal
                        : payment.paymentStatus === "PENDING"
                        ? colors.warning
                        : colors.danger,
                  }}
                >
                  {i18n.t(
                    payment.paymentStatus === "PAID"
                      ? "payment.paid"
                      : payment.paymentStatus === "PENDING"
                      ? "payment.payment-pending"
                      : "payment.payment-failed"
                  )}
                </span>
              </div>
              <div className="flex gap-2 items-center">
                <span className="text-xl font-bold">{`${i18n.t(
                  "payment.method"
                )}: `}</span>
                {payment.paymentMethod === "CREDIT_CARD" && (
                  <span>{i18n.t("payment.credit-card")}</span>
                )}
                {payment.paymentMethod === "MBWAY" && (
                  <Image
                    src="/img/mbway.svg"
                    height={40}
                    width={65}
                    alt="MbWay"
                  />
                )}
                {payment.paymentMethod === "MULTIBANCO" && (
                  <Image
                    src="/img/multibanco.svg"
                    height={60}
                    width={50}
                    alt="Multibanco"
                  />
                )}
              </div>
              {payment.paymentMethod === "MBWAY" && (
                <div>
                  <span className="text-xl font-bold">{`${i18n.t(
                    "phone"
                  )}: `}</span>
                  <span className="text-xl">{payment.mbwayPhone}</span>
                </div>
              )}
              {payment.paymentMethod === "MULTIBANCO" && (
                <Fragment>
                  <div>
                    <span className="text-xl font-bold">{`${i18n.t(
                      "payment.multibanco-entity"
                    )}: `}</span>
                    <span className="text-xl">{payment.multibancoEntity}</span>
                  </div>
                  <div>
                    <span className="text-xl font-bold">{`${i18n.t(
                      "payment.multibanco-reference"
                    )}: `}</span>
                    <span className="text-xl">
                      {payment.multibancoReference}
                    </span>
                  </div>
                </Fragment>
              )}
              <div>
                <span className="text-xl font-bold">{`${i18n.t(
                  "payment.amount"
                )}: `}</span>
                <span className="text-xl">{`€${payment.amount.toFixed(
                  2
                )}`}</span>
              </div>
              {/*{payment.paymentStatus !== "PAID" && (*/}
              {/*  <MyButton*/}
              {/*    marginTop*/}
              {/*    className="w-full mt-8"*/}
              {/*    onClick={() => setOpenRetryModal(true)}*/}
              {/*    title={i18n.t("payment.retry")}*/}
              {/*    color={colors.primary}*/}
              {/*  />*/}
              {/*)}*/}
              {/*<RetryPayment*/}
              {/*  payment={payment}*/}
              {/*  appointment={appointment}*/}
              {/*  opened={openRetryModal}*/}
              {/*  setOpened={setOpenRetryModal}*/}
              {/*/>*/}
            </div>
          </Modal>
        </Fragment>
      )}
    </Fragment>
  );
}
